module.exports = __webpack_public_path__ + "static/media/seller.a00c115b.png";